import React, { useState } from "react";
import { BrowserRouter, NavLink, Route } from "react-router-dom";
import ContentHeader from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import SessionTimeout from "../../../Dashboard/Components/SystemSettings/ApplicationSettings/SessionTimeout";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import MainSettings from "../../../Dashboard/Components/SystemSettings/ApplicationSettings/MainSettings";
import MaintainMode from "../../../Dashboard/Components/SystemSettings/ApplicationSettings/MaintainMode";
import UnsavedChangesAlert from "../../../Dashboard/Components/ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";

const ApplicationSettingsRoute = (props) => {
  const [HasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [LastClickedTab, setLastClickedTab] = useState();

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateNavigation = (e, Id) => {
    setLastClickedTab(Id);

    if (HasUnsavedChanges) {
      e.preventDefault();
      setModalIsOpen(true);
    } else {
      transformIndicator(Id);
    }
  };

  const transformIndicator = (Id) => {
    if (Id === "session-timeout") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(209px)";
    } else if (Id === "main") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else {
      document.getElementById("animated-indicator").style.transform =
        "translateX(418px)";
    }
  };

  const saveAndLeave = () => {
    document.getElementById("save-btn").click();
    setHasUnsavedChanges(false);
    setModalIsOpen(false);

    setTimeout(() => {
      document.getElementById(LastClickedTab).click();
    }, 700);
  };

  const discardAndLeave = () => {
    setHasUnsavedChanges(false);
    setModalIsOpen(false);
    setTimeout(() => {
      document.getElementById(LastClickedTab).click();
    }, 400);
  };

  return (
    <BrowserRouter basename="/home/applicationSettings">
      <div className="main-content security-settings system-settings app-settings">
        {ModalIsOpen ? (
          <UnsavedChangesAlert
            close={() => setModalIsOpen(false)}
            discardAndLeave={() => discardAndLeave()}
            saveAndLeave={() => saveAndLeave()}
          />
        ) : null}
        <ContentHeader PageName={translateText("application_settings")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("system_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("application_settings")}</p>
          </div>
        </div>
        <div className="navogator-holder">
          <div className="actions navigator">
            <span id="animated-indicator"></span>
            <NavLink
              onClick={(e) => validateNavigation(e, "main")}
              activeClassName="active-nav-node"
              exact
              id="main"
              to="/"
            >
              <p>{translateText("main_settings")}</p>
            </NavLink>
            <NavLink
              onClick={(e) => validateNavigation(e, "session-timeout")}
              activeClassName="active-nav-node"
              to="/sessionTimeout"
              id="session-timeout"
            >
              <p>{translateText("timeout_session")}</p>
            </NavLink>
            <NavLink
              onClick={(e) => validateNavigation(e, "maintain-mode")}
              activeClassName="active-nav-node"
              id="maintain-mode"
              to="/maintainMode"
            >
              <p>{translateText("maintain_mode")}</p>
            </NavLink>
          </div>
        </div>{" "}
      </div>
      <Route path="/maintainMode" exact>
        <MaintainMode
          LangData={props.LangData}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
        />
      </Route>
      <Route path="/sessionTimeout" exact>
        <SessionTimeout
          LangData={props.LangData}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
        />
      </Route>
      <Route path="/" exact>
        <MainSettings
          LangData={props.LangData}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
        />
      </Route>
    </BrowserRouter>
  );
};

export default ApplicationSettingsRoute;
